var _style, _polyline, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _line, _polygon7, _polygon8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOpenMenuBackgroundBottom = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "OpenMenuBackground_Bottom",
  x: "0px",
  y: "0px",
  viewBox: "0 0 950 200",
  style: {
    enableBackground: "new 0 0 950 200"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.stm0{fill:#38555A;}\r\n\t.stm1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  className: "stm0",
  points: "204.5,199.5 379.5,199.5 346.5,121.5 236.5,121.5 "
})), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  className: "stm0",
  points: "422.9,199.5 401,147 367.5,146.7 390.1,199.5 "
})), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
  className: "stm0",
  points: "466.7,199.5 444.8,147 411.3,146.7 433.9,199.5 "
})), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
  className: "stm0",
  points: "510.5,199.5 488.6,147 455.1,146.7 477.7,199.5 "
})), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
  className: "stm0",
  points: "554.3,199.5 532.3,147 498.9,146.7 521.5,199.5 "
})), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
  className: "stm0",
  points: "598,199.5 576.2,147 542.7,146.7 565.3,199.5 "
})), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
  className: "stm0",
  points: "641.9,199.5 620,147 586.5,146.7 609,199.5 "
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  className: "stm1",
  x1: 56.5,
  y1: 199.5,
  x2: 949.5,
  y2: 199.5
})), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
  className: "stm0",
  points: "196.3,189.5 213.5,150.8 155.9,147.5 "
}, /*#__PURE__*/React.createElement("animate", {
  accumulate: "none",
  additive: "replace",
  attributeName: "fill",
  attributeType: "XML",
  calcMode: "linear",
  dur: "5s",
  fill: "remove",
  repeatCount: "indefinite",
  restart: "always",
  values: "#55BC78;#dbff05;#55BC78;#55BC78"
}))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
  className: "stm0",
  points: "23.5,199.5 0,178.4 0,0 192.5,199.5 "
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOpenMenuBackgroundBottom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/OpenMenuBackground_Bottom.2c77ac8f.svg";
export { ForwardRef as ReactComponent };